import React, { useState, useEffect } from 'react';

const ZadostPristup = ({ token, onOdhlasit }) => {
  const [fveId, setFveId] = useState('');
  const [zprava, setZprava] = useState('');
  const [chyba, setChyba] = useState('');

  const odeslat = async () => {
    if (!fveId) { setChyba('Zadejte ID elektrárny'); return; }
    try {
      const res = await fetch('/api/zadost_pristup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ fve_id: fveId })
      });
      const json = await res.json();
      if (res.ok) setZprava('Žádost odeslána! Čeká na schválení administrátorem.');
      else setChyba(json.detail || 'Chyba');
    } catch (e) { setChyba('Chyba připojení'); }
  };

  return (
    <div style={{backgroundColor:'#1a1a2e',minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{backgroundColor:'#16213e',padding:'40px',borderRadius:'12px',width:'360px',boxShadow:'0 4px 20px rgba(0,0,0,0.5)'}}>
        <h1 style={{color:'#e94560',textAlign:'center',marginBottom:'10px'}}>⚡ FVE Monitor</h1>
        <p style={{color:'#aaa',textAlign:'center',marginBottom:'20px',fontSize:'14px'}}>Zadejte ID vaší elektrárny</p>
        {zprava ? (
          <div style={{color:'#4ade80',fontSize:'14px',textAlign:'center',marginBottom:'20px'}}>{zprava}</div>
        ) : (
          <>
            <div style={{marginBottom:'15px'}}>
              <label style={{color:'#aaa',fontSize:'13px'}}>ID elektrárny</label>
              <input value={fveId} onChange={e => setFveId(e.target.value.toUpperCase())}
                style={{width:'100%',padding:'10px',marginTop:'5px',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'6px',color:'white',fontSize:'14px',boxSizing:'border-box'}}
                placeholder="FVE001"/>
            </div>
            {chyba && <div style={{color:'#ef4444',fontSize:'13px',marginBottom:'15px',textAlign:'center'}}>{chyba}</div>}
            <button onClick={odeslat}
              style={{width:'100%',padding:'12px',backgroundColor:'#e94560',border:'none',borderRadius:'6px',color:'white',fontSize:'16px',fontWeight:'bold',cursor:'pointer'}}>
              Požádat o přístup
            </button>
          </>
        )}
        <div style={{textAlign:'center',marginTop:'15px'}}>
          <span onClick={onOdhlasit} style={{color:'#aaa',fontSize:'13px',cursor:'pointer'}}>Odhlásit se</span>
        </div>
      </div>
    </div>
  );
};

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [heslo, setHeslo] = useState('');
  const [chyba, setChyba] = useState('');
  const [rezim, setRezim] = useState('login');
  const [jmeno, setJmeno] = useState('');
  const [prijmeni, setPrijmeni] = useState('');
  const [heslo2, setHeslo2] = useState('');
  const [zobrazHeslo, setZobrazHeslo] = useState(false);
  const [uspech, setUspech] = useState('');

  const handleLogin = async () => {
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `username=${encodeURIComponent(email)}&password=${encodeURIComponent(heslo)}`
      });
      const json = await res.json();
      if (res.ok) {
        localStorage.clear();
        localStorage.setItem('token', json.access_token);
        localStorage.setItem('role', json.role);
        localStorage.setItem('jmeno', json.jmeno);
        localStorage.setItem('userEmail', email);
        const elRes = await fetch('/api/moje_elektrarny', {
          headers: { 'Authorization': `Bearer ${json.access_token}` }
        });
        const elJson = await elRes.json();
        console.log('elektrarny po loginu:', elJson);
        const lsKey = `aktivniElektrarna_${email}`;
        if (elJson.length >= 1) localStorage.setItem(lsKey, elJson[0].fve_id);
        onLogin(json, elJson.length >= 1 ? elJson[0].fve_id : '');
      } else {
        setChyba('Špatné přihlašovací údaje');
      }
    } catch (e) {
      setChyba('Chyba připojení');
    }
  };

  const handleRegistrace = async () => {
    if (!jmeno || !prijmeni || !email || !heslo || !heslo2) { setChyba('Vyplňte všechna pole'); return; }
    if (heslo !== heslo2) { setChyba('Hesla se neshodují'); return; }
    try {
      const res = await fetch('/api/registrace', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jmeno, prijmeni, email, heslo })
      });
      const json = await res.json();
      if (res.ok) {
        setUspech('Účet vytvořen! Přihlaste se.');
        setRezim('login');
        setChyba('');
      } else {
        setChyba(json.detail || 'Chyba registrace');
      }
    } catch (e) {
      setChyba('Chyba připojení');
    }
  };

  return (
    <div style={{backgroundColor:'#1a1a2e',minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{backgroundColor:'#16213e',padding:'40px',borderRadius:'12px',width:'360px',boxShadow:'0 4px 20px rgba(0,0,0,0.5)'}}>
        <h1 style={{color:'#e94560',textAlign:'center',marginBottom:'10px'}}>⚡ FVE Monitor</h1>
        <p style={{color:'#aaa',textAlign:'center',marginBottom:'20px',fontSize:'14px'}}>
          {rezim === 'login' ? 'Přihlaste se pro přístup k systému' : 'Vytvořte nový účet'}
        </p>
        {uspech && <div style={{color:'#4ade80',fontSize:'13px',marginBottom:'15px',textAlign:'center'}}>{uspech}</div>}
        {rezim === 'registrace' && (
          <>
            <div style={{marginBottom:'15px'}}>
              <label style={{color:'#aaa',fontSize:'13px'}}>Jméno</label>
              <input value={jmeno} onChange={e => setJmeno(e.target.value)}
                style={{width:'100%',padding:'10px',marginTop:'5px',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'6px',color:'white',fontSize:'14px',boxSizing:'border-box'}}
                placeholder="Jan"/>
            </div>
            <div style={{marginBottom:'15px'}}>
              <label style={{color:'#aaa',fontSize:'13px'}}>Příjmení</label>
              <input value={prijmeni} onChange={e => setPrijmeni(e.target.value)}
                style={{width:'100%',padding:'10px',marginTop:'5px',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'6px',color:'white',fontSize:'14px',boxSizing:'border-box'}}
                placeholder="Novák"/>
            </div>
          </>
        )}
        <div style={{marginBottom:'15px'}}>
          <label style={{color:'#aaa',fontSize:'13px'}}>Email</label>
          <input value={email} onChange={e => setEmail(e.target.value)}
            style={{width:'100%',padding:'10px',marginTop:'5px',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'6px',color:'white',fontSize:'14px',boxSizing:'border-box'}}
            placeholder="vas@email.cz" type="email"/>
        </div>
        <div style={{marginBottom:'15px'}}>
          <label style={{color:'#aaa',fontSize:'13px'}}>Heslo</label>
          <div style={{position:'relative'}}>
            <input value={heslo} onChange={e => setHeslo(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && (rezim === 'login' ? handleLogin() : handleRegistrace())}
              style={{width:'100%',padding:'10px',marginTop:'5px',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'6px',color:'white',fontSize:'14px',boxSizing:'border-box'}}
              placeholder="••••••••" type={zobrazHeslo ? 'text' : 'password'}/>
            <span onClick={() => setZobrazHeslo(!zobrazHeslo)}
              style={{position:'absolute',right:'10px',top:'14px',cursor:'pointer',color:'#aaa',fontSize:'16px'}}>
              {zobrazHeslo ? '🙈' : '👁️'}
            </span>
          </div>
        </div>
        {rezim === 'registrace' && (
          <div style={{marginBottom:'20px'}}>
            <label style={{color:'#aaa',fontSize:'13px'}}>Heslo znovu</label>
            <div style={{position:'relative'}}>
              <input value={heslo2} onChange={e => setHeslo2(e.target.value)}
                style={{width:'100%',padding:'10px',marginTop:'5px',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'6px',color:'white',fontSize:'14px',boxSizing:'border-box'}}
                placeholder="••••••••" type={zobrazHeslo ? 'text' : 'password'}/>
            </div>
          </div>
        )}
        {chyba && <div style={{color:'#ef4444',fontSize:'13px',marginBottom:'15px',textAlign:'center'}}>{chyba}</div>}
        <button onClick={rezim === 'login' ? handleLogin : handleRegistrace}
          style={{width:'100%',padding:'12px',backgroundColor:'#e94560',border:'none',borderRadius:'6px',color:'white',fontSize:'16px',fontWeight:'bold',cursor:'pointer'}}>
          {rezim === 'login' ? 'Přihlásit se' : 'Registrovat se'}
        </button>
        <div style={{textAlign:'center',marginTop:'15px'}}>
          <span style={{color:'#aaa',fontSize:'13px'}}>
            {rezim === 'login' ? 'Nemáte účet? ' : 'Máte účet? '}
            <span onClick={() => { setRezim(rezim === 'login' ? 'registrace' : 'login'); setChyba(''); setUspech(''); }}
              style={{color:'#00b4d8',cursor:'pointer'}}>
              {rezim === 'login' ? 'Registrovat se' : 'Přihlásit se'}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

const API = '';

const FazeSloupec = ({ nazev, hodnota, max }) => {
  const procent = Math.min((hodnota / max) * 100, 100);
  const barva = procent < 60 ? '#4ade80' : procent < 80 ? '#fbbf24' : '#ef4444';
  return (
    <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'}}>
      <div style={{color:'#aaa',fontSize:'14px'}}>{nazev}</div>
      <div style={{width:'200px',height:'500px',backgroundColor:'#0f3460',borderRadius:'8px',display:'flex',alignItems:'flex-end',overflow:'hidden'}}>
        <div style={{width:'100%',height:`${procent}%`,backgroundColor:barva,borderRadius:'8px',transition:'height 0.5s,background-color 0.5s'}}/>
      </div>
      <div style={{color:barva,fontWeight:'bold',fontSize:'16px'}}>{hodnota} W</div>
      <div style={{color:'#aaa',fontSize:'13px'}}>{procent.toFixed(0)}%</div>
    </div>
  );
};

const StuderSloupec = ({ nazev, hodnota, max }) => {
  const procent = Math.min((hodnota / max) * 100, 100);
  const barva = procent < 60 ? '#4ade80' : procent < 80 ? '#fbbf24' : '#ef4444';
  return (
    <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'}}>
      <div style={{color:'#aaa',fontSize:'14px'}}>{nazev}</div>
      <div style={{width:'80px',height:'300px',backgroundColor:'#0f3460',borderRadius:'8px',display:'flex',alignItems:'flex-end',overflow:'hidden'}}>
        <div style={{width:'100%',height:`${procent}%`,backgroundColor:barva,borderRadius:'8px',transition:'height 0.5s,background-color 0.5s'}}/>
      </div>
      <div style={{color:barva,fontWeight:'bold',fontSize:'16px'}}>{hodnota.toFixed(2)} kW</div>
    </div>
  );
};

const BaterieSloupec = ({ hodnota }) => {
  const barva = hodnota > 50 ? '#4ade80' : hodnota > 20 ? '#fbbf24' : '#ef4444';
  return (
    <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px'}}>
      <div style={{color:'#aaa',fontSize:'14px'}}>🔋 Baterie SOC</div>
      <div style={{width:'200px',height:'500px',backgroundColor:'#0f3460',borderRadius:'8px',display:'flex',alignItems:'flex-end',overflow:'hidden'}}>
        <div style={{width:'100%',height:`${hodnota}%`,backgroundColor:barva,borderRadius:'8px',transition:'height 0.5s,background-color 0.5s'}}/>
      </div>
      <div style={{color:barva,fontWeight:'bold',fontSize:'16px'}}>{hodnota} %</div>
      <div style={{color:'#aaa',fontSize:'13px'}}>nabití</div>
    </div>
  );
};

const Karta = ({ nazev, hodnota, jednotka, barva, ikona }) => (
  <div style={{backgroundColor:'#16213e',borderRadius:'10px',padding:'20px',borderLeft:`4px solid ${barva}`}}>
    <div style={{color:'#aaa',fontSize:'14px'}}>{ikona} {nazev}</div>
    <div style={{fontSize:'28px',fontWeight:'bold',color:barva}}>{Number(hodnota).toFixed(2)} {jednotka}</div>
  </div>
);

const Menu = ({ aktivni, setAktivni, role }) => (
  <div style={{backgroundColor:'#0f3460',display:'flex',gap:'5px',padding:'0 30px',overflowX:'auto',flexWrap:'nowrap'}}>
    {['Přehled','Data','Grafy',...(['super_admin','servisni_technik','technicky_dispecer','analytik','vyvojar_sw','vyvojovy_technik','obchodnik'].includes(role)?['Nastavení']:[]),'Historie'].map(item => (
      <button key={item} onClick={() => setAktivni(item)}
        style={{backgroundColor:aktivni===item?'#e94560':'transparent',color:'white',border:'none',padding:'12px 20px',cursor:'pointer',fontSize:'14px',borderRadius:'5px 5px 0 0'}}>
        {item}
      </button>
    ))}
    {['super_admin','servisni_technik','technicky_dispecer','analytik','vyvojar_sw','vyvojovy_technik','obchodnik'].includes(role) && (
      <button onClick={() => setAktivni('Elektrárny')}
        style={{backgroundColor:aktivni==='Elektrárny'?'#e94560':'transparent',color:'white',border:'none',padding:'12px 20px',cursor:'pointer',fontSize:'14px',borderRadius:'5px 5px 0 0'}}>
        Elektrárny
      </button>
    )}
    {['super_admin','servisni_technik','vyvojovy_technik'].includes(role) && (
      <button onClick={() => setAktivni('Správa uživatelů')}
        style={{backgroundColor:aktivni==='Správa uživatelů'?'#e94560':'transparent',color:'white',border:'none',padding:'12px 20px',cursor:'pointer',fontSize:'14px',borderRadius:'5px 5px 0 0'}}>
        Správa uživatelů
      </button>
    )}
  </div>
);

const DEYE_NAZVY = {
  L1_inverter_output_power: { nazev: 'L1 Výkon střídače', jednotka: 'W' },
  L2_inverter_output_power: { nazev: 'L2 Výkon střídače', jednotka: 'W' },
  L3_inverter_output_power: { nazev: 'L3 Výkon střídače', jednotka: 'W' },
  total_inverter_output_power: { nazev: 'Celkový výkon střídače', jednotka: 'W' },
  PV1_input_power: { nazev: 'PV1 Vstupní výkon', jednotka: 'W' },
  PV1_voltage: { nazev: 'PV1 Napětí', jednotka: 'V', des: 1 },
  PV1_current: { nazev: 'PV1 Proud', jednotka: 'A', des: 2 },
  PV2_input_power: { nazev: 'PV2 Vstupní výkon', jednotka: 'W' },
  PV2_voltage: { nazev: 'PV2 Napětí', jednotka: 'V', des: 1 },
  PV2_current: { nazev: 'PV2 Proud', jednotka: 'A', des: 2 },
  battery_soc: { nazev: 'Baterie SOC', jednotka: '%' },
  battery_voltage: { nazev: 'Napětí baterie', jednotka: 'V' },
  battery_output_current: { nazev: 'Proud baterie', jednotka: 'A' },
  battery_cycle_count: { nazev: 'Počet cyklů baterie', jednotka: '' },
  battery_capacity: { nazev: 'Kapacita baterie', jednotka: 'Ah' },
  bms_soc: { nazev: 'BMS SOC', jednotka: '%', des: 0 },
  bms_napeti: { nazev: 'BMS Napětí', jednotka: 'V' },
  bms_proud: { nazev: 'BMS Proud', jednotka: 'A' },
  bms_cykly: { nazev: 'BMS Cykly', jednotka: '', des: 0 },
  bms_delta_mv: { nazev: 'BMS Delta článků', jednotka: 'V', des: 3, scale: 0.001 },
  bms_min_clanek: { nazev: 'BMS Min článek', jednotka: 'V', des: 3 },
  bms_max_clanek: { nazev: 'BMS Max článek', jednotka: 'V', des: 3 },
  bms_temp_mos: { nazev: 'BMS Teplota MOS', jednotka: '°C' },
  bms_temp_bat1: { nazev: 'BMS Teplota 1', jednotka: '°C' },
  bms_temp_bat2: { nazev: 'BMS Teplota 2', jednotka: '°C' },
  bms_temp_bat3: { nazev: 'BMS Teplota 3', jednotka: '°C' },
  bms_temp_bat4: { nazev: 'BMS Teplota 4', jednotka: '°C' },
  bms_temp_bat5: { nazev: 'BMS Teplota 5', jednotka: '°C' },
  absorption_voltage: { nazev: 'Absorpční napětí', jednotka: 'V' },
  float_voltage: { nazev: 'Float napětí', jednotka: 'V' },
  empty_voltage: { nazev: 'Prázdné napětí', jednotka: 'V' },
  equalization_voltage: { nazev: 'Vyrovnávací napětí', jednotka: 'V' },
  run_state: { nazev: 'Stav běhu', jednotka: '' },
  today_active_power_generation: { nazev: 'Dnešní výroba', jednotka: 'kWh' },
  today_charge_of_battery: { nazev: 'Dnešní nabití baterie', jednotka: 'kWh' },
  today_discharge_of_battery: { nazev: 'Dnešní vybití baterie', jednotka: 'kWh' },
  today_grid_connection_time: { nazev: 'Čas připojení sítě dnes', jednotka: 's' },
  today_reactive_power_generation: { nazev: 'Dnešní reaktivní výroba', jednotka: 'kVarh' },
  day_grid_buy_power: { nazev: 'Nákup ze sítě dnes', jednotka: 'kWh' },
  day_grid_sell_power: { nazev: 'Prodej do sítě dnes', jednotka: 'kWh' },
  day_load_power_wh: { nazev: 'Spotřeba dnes', jednotka: 'kWh' },
  day_pv_power_wh: { nazev: 'PV výroba dnes', jednotka: 'kWh' },
  day_pv1_power_wh: { nazev: 'PV1 výroba dnes', jednotka: 'kWh' },
  day_pv2_power_wh: { nazev: 'PV2 výroba dnes', jednotka: 'kWh' },
  total_active_power_generation: { nazev: 'Celková výroba', jednotka: 'kWh' },
  total_charge_of_battery: { nazev: 'Celkové nabití baterie', jednotka: 'kWh' },
  total_discharge_of_battery: { nazev: 'Celkové vybití baterie', jednotka: 'kWh' },
  total_grid_buy_power: { nazev: 'Celkový nákup ze sítě', jednotka: 'kWh' },
  total_grid_sell_power: { nazev: 'Celkový prodej do sítě', jednotka: 'kWh' },
  total_load_power_wh: { nazev: 'Celková spotřeba', jednotka: 'kWh' },
  total_pv_power: { nazev: 'Celková PV výroba', jednotka: 'kWh' },
  total_reactive_power_generation: { nazev: 'Celková reaktivní výroba', jednotka: 'kVarh' },
  generator_working_hours_per_day: { nazev: 'Motohodiny dnes', jednotka: 'h' },
  dc_transformer_temp: { nazev: 'Teplota DC transformátoru', jednotka: '°C' },
  heatsink_temp: { nazev: 'Teplota chladiče', jednotka: '°C' },
};

const NASTAVENI_PARAMETRY = [
  { sekce: 'Napětí baterie', parametry: [
    { klic: 'absorption_voltage', nazev: 'Absorpční napětí', jednotka: 'V', krok: 0.01 },
    { klic: 'float_voltage', nazev: 'Float napětí', jednotka: 'V', krok: 0.01 },
    { klic: 'empty_voltage', nazev: 'Prázdné napětí', jednotka: 'V', krok: 0.01 },
    { klic: 'equalization_voltage', nazev: 'Vyrovnávací napětí', jednotka: 'V', krok: 0.01 },
  ]},
  { sekce: 'Kapacita a SOC', parametry: [
    { klic: 'battery_capacity', nazev: 'Kapacita baterie', jednotka: 'Ah', krok: 1 },
    { klic: 'battery_shutdown_soc', nazev: 'SOC vypnutí', jednotka: '%', krok: 1 },
    { klic: 'battery_restart_soc', nazev: 'SOC restart', jednotka: '%', krok: 1 },
    { klic: 'battery_lowbatt_soc', nazev: 'SOC nízká baterie', jednotka: '%', krok: 1 },
  ]},
  { sekce: 'Proudové limity', parametry: [
    { klic: 'max_charge_current', nazev: 'Max nabíjecí proud', jednotka: 'A', krok: 1, varovani: 'Pozor – ovlivňuje životnost baterie' },
    { klic: 'max_discharge_current', nazev: 'Max vybíjecí proud', jednotka: 'A', krok: 1, varovani: 'Pozor – ovlivňuje životnost baterie' },
  ]},
  { sekce: 'Generátor', parametry: [
    { klic: 'generator_max_time', nazev: 'Max doba běhu', jednotka: 'h', krok: 0.1 },
    { klic: 'generator_cooling_time', nazev: 'Doba chlazení', jednotka: 'h', krok: 0.1 },
    { klic: 'generator_start_soc', nazev: 'SOC spuštění', jednotka: '%', krok: 1 },
    { klic: 'generator_charge_current', nazev: 'Nabíjecí proud z generátoru', jednotka: 'A', krok: 1 },
  ]},
];

const STUDER_SKUPINY = [
  { nazev: 'Základní', params: [1107, 1138, 1126, 1124, 1125, 1187, 1552] },
  { nazev: 'Baterie — napětí', params: [1140, 1156, 1157, 1164, 1172, 1108, 1110] },
  { nazev: 'Invertor', params: [1112, 1286] },
  { nazev: 'AC-IN', params: [1128, 1199, 1200] },
];

const StuderNastaveniForm = ({ fveId, token }) => {
  const [params, setParams] = useState(null);
  const [hodnoty, setHodnoty] = useState({});
  const [stav, setStav] = useState(null);
  const [ukladam, setUkladam] = useState(false);

  useEffect(() => {
    fetch(`/api/studer_params/${fveId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => setParams(d))
      .catch(() => setParams({}));
  }, [fveId]);

  const zapsat = async (paramId) => {
    if (!hodnoty[paramId] && hodnoty[paramId] !== 0) return;
    setUkladam(true);
    try {
      const res = await fetch(`/api/studer_params/${fveId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ param_id: paramId, hodnota: parseFloat(hodnoty[paramId]) })
      });
      const json = await res.json();
      if (json.ok) {
        setStav({ typ: 'ok', zprava: `Parametr ${paramId} zapsán` });
        setHodnoty(h => ({ ...h, [paramId]: '' }));
        setTimeout(() => fetch(`/api/studer_params/${fveId}`, { headers: { Authorization: `Bearer ${token}` } })
          .then(r => r.json()).then(d => setParams(d)), 2000);
      } else {
        setStav({ typ: 'chyba', zprava: 'Chyba zápisu' });
      }
    } catch (e) {
      setStav({ typ: 'chyba', zprava: e.message });
    }
    setUkladam(false);
  };

  if (!params) return <div style={{color:'#aaa'}}>Načítám parametry Studer...</div>;

  return (
    <div style={{maxWidth:'800px'}}>
      <h2 style={{color:'#f59e0b',marginBottom:'20px'}}>⚡ Nastavení Studer</h2>
      {stav && <div style={{padding:'10px',borderRadius:'6px',marginBottom:'15px',backgroundColor:stav.typ==='ok'?'#14532d':'#7f1d1d',color:stav.typ==='ok'?'#4ade80':'#ef4444'}}>{stav.zprava}</div>}
      {STUDER_SKUPINY.map(skupina => (
        <div key={skupina.nazev} style={{marginBottom:'25px'}}>
          <h3 style={{color:'#f59e0b',borderBottom:'1px solid #0f3460',paddingBottom:'8px',marginBottom:'15px'}}>{skupina.nazev}</h3>
          {skupina.params.map(pid => {
            const p = params[String(pid)];
            if (!p) return null;
            return (
              <div key={pid} style={{display:'flex',gap:'10px',alignItems:'center',marginBottom:'10px',backgroundColor:'#16213e',padding:'12px',borderRadius:'8px'}}>
                <div style={{flex:1}}>
                  <div style={{color:'white',fontSize:'14px'}}>{p.nazev}</div>
                  <div style={{color:'#aaa',fontSize:'12px'}}>Aktuálně: <span style={{color:'#f59e0b'}}>{p.hodnota !== null ? p.hodnota : '---'} {p.jednotka}</span> | min: {p.min} | max: {p.max}</div>
                </div>
                <input
                  type="number"
                  placeholder="Nová hodnota"
                  value={hodnoty[pid] || ''}
                  onChange={e => setHodnoty(h => ({...h, [pid]: e.target.value}))}
                  step="0.1"
                  min={p.min}
                  max={p.max}
                  style={{width:'120px',padding:'6px',backgroundColor:'#0f3460',border:'1px solid #3b4d6b',borderRadius:'4px',color:'white'}}
                />
                <button
                  onClick={() => zapsat(pid)}
                  disabled={ukladam || !hodnoty[pid]}
                  style={{padding:'6px 14px',backgroundColor:'#f59e0b',border:'none',borderRadius:'4px',color:'black',cursor:'pointer',fontWeight:'bold'}}>
                  Zapsat
                </button>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

const NastaveniForm = ({ fveId, token, data, onStav, hasPerm }) => {
  const [hodnoty, setHodnoty] = useState({});
  const [ukladam, setUkladam] = useState(false);

  const zmenHodnotu = (klic, val) => setHodnoty(h => ({ ...h, [klic]: val }));

  const zapsat = async () => {
    const vybrane = Object.fromEntries(
      Object.entries(hodnoty).filter(([k, v]) => v !== '' && v !== null && v !== undefined)
    );
    if (Object.keys(vybrane).length === 0) { onStav({ typ: 'chyba', zprava: 'Nevyplnil jsi žádnou hodnotu' }); return; }
    setUkladam(true);
    onStav(null);
    try {
      const res = await fetch(`/api/zapis/${fveId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(vybrane)
      });
      const json = await res.json();
      if (json.uspech) {
        onStav({ typ: 'ok', zprava: 'Zapsáno úspěšně' + (json.dry_run ? ' (DRY RUN - simulace)' : '') });
        setHodnoty({});
      } else {
        onStav({ typ: 'chyba', zprava: json.chyba || 'Chyba zápisu' });
      }
    } catch (e) {
      onStav({ typ: 'chyba', zprava: 'Chyba připojení: ' + e.message });
    }
    setUkladam(false);
  };

  return (
    <div style={{maxWidth:'800px',width:'100%',boxSizing:'border-box'}}>
      <h2 style={{color:'#e94560',marginBottom:'20px'}}>Nastavení DEYE</h2>
      {NASTAVENI_PARAMETRY.map(sekce => (
        <div key={sekce.sekce} style={{marginBottom:'25px'}}>
          <div style={{color:'#aaa',fontSize:'13px',fontWeight:'500',borderBottom:'1px solid #0f3460',paddingBottom:'6px',marginBottom:'12px'}}>{sekce.sekce}</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
            {sekce.parametry.map(p => (
              <div key={p.klic} style={{backgroundColor:'#16213e',borderRadius:'8px',padding:'12px 14px'}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:'8px'}}>
                  <div style={{color:'white',fontSize:'14px',fontWeight:'500'}}>{p.nazev}</div>
                  <div style={{color:'#aaa',fontSize:'13px'}}>
                    {data[p.klic] !== undefined ? `${Number(data[p.klic]).toFixed(2)} ${p.jednotka}` : '---'}
                  </div>
                </div>
                <input type="number" step={p.krok} placeholder={`Nová hodnota (${p.jednotka})`}
                  value={hodnoty[p.klic] || ''}
                  onChange={e => zmenHodnotu(p.klic, e.target.value)}
                  style={{width:'100%',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'5px',color:'white',padding:'6px 10px',fontSize:'13px',boxSizing:'border-box'}}/>
                {p.varovani && <div style={{color:'#fbbf24',fontSize:'11px',marginTop:'5px'}}>{p.varovani}</div>}
              </div>
            ))}
          </div>
        </div>
      ))}
      {(!hasPerm || hasPerm('zapisovat_parametry')) && (
        <button onClick={zapsat} disabled={ukladam}
          style={{width:'100%',padding:'14px',backgroundColor:ukladam?'#555':'#e94560',border:'none',borderRadius:'8px',color:'white',fontSize:'16px',fontWeight:'bold',cursor:ukladam?'not-allowed':'pointer'}}>
          {ukladam ? 'Zapisuji...' : 'Zapsat parametry'}
        </button>
      )}
    </div>
  );
};

const ElektrarnyPanel = ({ elektrarny, aktivniElektrarna, onVybrat }) => {
  const [razeni, setRazeni] = useState('id');
  const [smer, setSmer] = useState('asc');

  const prepniRazeni = (klic) => {
    if (razeni === klic) setSmer(s => s === 'asc' ? 'desc' : 'asc');
    else { setRazeni(klic); setSmer('asc'); }
  };

  const serazeno = [...elektrarny].sort((a, b) => {
    let res = 0;
    if (razeni === 'id') res = a.fve_id.localeCompare(b.fve_id);
    if (razeni === 'nazev') res = (a.nazev||'').localeCompare(b.nazev||'');
    if (razeni === 'prijmeni') res = (a.prijmeni||'').localeCompare(b.prijmeni||'');
    return smer === 'asc' ? res : -res;
  });

  const thStyle = (klic) => ({
    color: razeni === klic ? '#00b4d8' : '#aaa',
    padding:'10px 15px',textAlign:'left',fontSize:'13px',cursor:'pointer',userSelect:'none'
  });

  return (
    <div>
      <h2 style={{color:'#e94560',marginBottom:'20px'}}>🏭 Elektrárny</h2>
      <table style={{width:'100%',borderCollapse:'collapse'}}>
        <thead>
          <tr style={{backgroundColor:'#0f3460'}}>
            <th style={thStyle('id')} onClick={() => prepniRazeni('id')}>FVE ID {razeni==='id'&&(smer==='asc'?'▲':'▼')}</th>
            <th style={thStyle('nazev')} onClick={() => prepniRazeni('nazev')}>Název {razeni==='nazev'&&(smer==='asc'?'▲':'▼')}</th>
            <th style={{color:'#aaa',padding:'10px 15px',textAlign:'left',fontSize:'13px'}}>Jméno</th>
            <th style={thStyle('prijmeni')} onClick={() => prepniRazeni('prijmeni')}>Příjmení {razeni==='prijmeni'&&(smer==='asc'?'▲':'▼')}</th>
            <th style={{color:'#aaa',padding:'10px 15px',textAlign:'left',fontSize:'13px'}}>Místní IP</th>
            <th style={{color:'#aaa',padding:'10px 15px',textAlign:'left',fontSize:'13px'}}>Stav</th>
            <th style={{color:'#aaa',padding:'10px 15px',textAlign:'left',fontSize:'13px'}}>Akce</th>
          </tr>
        </thead>
        <tbody>
          {serazeno.map(e => (
            <tr key={e.fve_id}
              style={{backgroundColor: e.fve_id === aktivniElektrarna ? '#1a3a5c' : '#16213e', borderBottom:'1px solid #0f3460'}}>
              <td style={{padding:'12px 15px',color: e.fve_id === aktivniElektrarna ? '#00b4d8' : 'white',fontWeight: e.fve_id === aktivniElektrarna ? 'bold' : 'normal',fontSize:'14px'}}>
                {e.fve_id} {e.fve_id === aktivniElektrarna && '◀'}
              </td>
              <td style={{padding:'12px 15px',color:'#ccc',fontSize:'14px'}}>{e.nazev || '—'}</td>
              <td style={{padding:'12px 15px',color:'#ccc',fontSize:'14px'}}>{e.jmeno || '—'}</td>
              <td style={{padding:'12px 15px',color:'#ccc',fontSize:'14px'}}>{e.prijmeni || '—'}</td>
              <td style={{padding:'12px 15px',color:'#8b5cf6',fontSize:'13px'}}>{e.local_ip || '—'}</td>
              <td style={{padding:'12px 15px'}}>
                <span style={{fontSize:'12px',padding:'3px 8px',borderRadius:'10px',
                  backgroundColor: e.aktivni ? '#14532d' : '#3a1a1a',
                  color: e.aktivni ? '#4ade80' : '#f87171'}}>
                  {e.aktivni ? '● aktivní' : '○ neaktivní'}
                </span>
              </td>
              <td style={{padding:'12px 15px'}}>
                {e.fve_id !== aktivniElektrarna ? (
                  <button onClick={() => onVybrat(e.fve_id)}
                    style={{backgroundColor:'#e94560',border:'none',padding:'6px 14px',borderRadius:'5px',color:'white',cursor:'pointer',fontSize:'13px'}}>
                    Přepnout
                  </button>
                ) : (
                  <span style={{color:'#4ade80',fontSize:'13px'}}>Zobrazená</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

function App() {
  const [uzivatel, setUzivatel] = useState(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const jmeno = localStorage.getItem('jmeno');
    return token ? { token, role, jmeno } : null;
  });
  const [myPermissions, setMyPermissions] = useState([]);
  const hasPerm = (perm) => myPermissions.includes(perm);
  const [elektrarny, setElektrarny] = useState([]);
  const [aktivniElektrarna, setAktivniElektrarna] = useState(() => {
    const email = localStorage.getItem('userEmail') || '';
    return localStorage.getItem(`aktivniElektrarna_${email}`) || '';
  });
  const [aktivni, setAktivni] = useState('Přehled');
  const [maMotor, setMaMotor] = useState(false);
  const [pocetFazi, setPocetFazi] = useState(3);
  const [deye, setDeye] = useState({});
  const [posledniAktualizace, setPosledniAktualizace] = useState(null);
  const [online, setOnline] = useState(true);
  const [casZtraty, setCasZtraty] = useState(null);
  const casZtratyRef = React.useRef(null);
  const [odpocet, setOdpocet] = useState('');
  const [zapisStav, setZapisStav] = useState(null);
  const [nastaveniTab, setNastaveniTab] = useState('DEYE');

  useEffect(() => {
    if (zapisStav) {
      const t = setTimeout(() => setZapisStav(null), 5000);
      return () => clearTimeout(t);
    }
  }, [zapisStav]);

  const lsKey = () => `aktivniElektrarna_${localStorage.getItem('userEmail') || ''}`;

  const nastavAktivni = (fveId) => {
    setAktivniElektrarna(fveId);
    localStorage.setItem(lsKey(), fveId);
  };

  useEffect(() => {
    if (!uzivatel) return;
    const nactiElektrarny = async () => {
      try {
        const res = await fetch('/api/moje_elektrarny', {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const json = await res.json();
        setElektrarny(json);
        const klic = lsKey();
        const ulozena = localStorage.getItem(klic);
        if (!ulozena && json.length >= 1) {
          nastavAktivni(json[0].fve_id);
        }
      } catch (e) {
        console.error('Chyba načítání elektráren:', e);
      }
    };
    nactiElektrarny();
    fetch('/api/me/permissions', { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } })
      .then(r => r.json()).then(data => { if (data.permissions) setMyPermissions(data.permissions); }).catch(() => {});
  }, [uzivatel]);

  useEffect(() => {
    const fetchData = async () => {
      if (!aktivniElektrarna) return;
      try {
        const res = await fetch(`${API}/api/data/${aktivniElektrarna}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        if (res.status === 401) { localStorage.clear(); setUzivatel(null); return; }
        const json = await res.json();
        if (json.deye) {
          setDeye(json.deye);
          setPosledniAktualizace(new Date().toLocaleTimeString('cs-CZ'));
        }
        const statusRes = await fetch(`${API}/api/status/${aktivniElektrarna}`, {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        });
        const statusJson = await statusRes.json();
        if (statusJson.posledni_data) {
          const posledni = new Date(statusJson.posledni_data);
          const rozdil = (new Date() - posledni) / 1000;
          if (rozdil < 10) {
            setOnline(true);
            casZtratyRef.current = null;
            setCasZtraty(null);
          } else {
            if (!casZtratyRef.current) {
              const now = new Date();
              casZtratyRef.current = now;
              setCasZtraty(now);
            }
            setOnline(false);
          }
        }
      } catch (e) {
        setOnline(false);
      }
    };
    fetchData();
    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, [aktivniElektrarna]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (casZtratyRef.current) {
        const diff = Math.floor((new Date() - casZtratyRef.current) / 1000);
        const d = Math.floor(diff / 86400);
        const h = Math.floor((diff % 86400) / 3600);
        const m = Math.floor((diff % 3600) / 60);
        const s = diff % 60;
        if (d > 0) setOdpocet(`${d}d ${h}h ${m}m ${s}s`);
        else if (h > 0) setOdpocet(`${h}h ${m}m ${s}s`);
        else if (m > 0) setOdpocet(`${m}m ${s}s`);
        else setOdpocet(`${s}s`);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const d = deye;
  const bmsAverageSoc = (() => {
    const hodnoty = [];
    const limitSec = 60;
    for (let i = 0; i < 16; i++) {
      const id = String(i).padStart(2, '0');
      const soc = d?.[`bms${id}_soc`];
      const lu = d?.[`bms${id}_last_update`];
      if (soc === undefined) continue;
      if (lu) {
        const stariSec = (Date.now() - new Date(lu).getTime()) / 1000;
        if (stariSec > limitSec) continue;
      }
      hodnoty.push(soc);
    }
    return hodnoty.length > 0 ? Math.round(hodnoty.reduce((a,b) => a+b, 0) / hodnoty.length) : null;
  })();
  const dataNastaveni = React.useMemo(() => ({...d}), [d.absorption_voltage, d.float_voltage, d.empty_voltage, d.equalization_voltage, d.battery_capacity]);

  if (!uzivatel) return <Login onLogin={(u, fveId) => { setUzivatel(u); if (fveId) setAktivniElektrarna(fveId); }} />;
  if (!aktivniElektrarna && uzivatel?.role === 'zakaznik') return (
    <ZadostPristup token={localStorage.getItem('token')} onOdhlasit={() => { localStorage.clear(); setUzivatel(null); }} />
  );

  return (
    <div style={{backgroundColor:'#1a1a2e',minHeight:'100vh',color:'white',fontFamily:'Arial'}}>
      <div style={{backgroundColor:'#16213e',padding:'15px 30px',display:'flex',alignItems:'center'}}>
        <h1 style={{margin:0,color:'#e94560',fontSize:'24px'}}>⚡ FVE Monitor</h1>
        <span style={{marginLeft:'20px',color:'#00b4d8'}}>{aktivniElektrarna} - {uzivatel?.jmeno}</span>
        <button onClick={() => { localStorage.clear(); setUzivatel(null); }}
          style={{marginLeft:'20px',backgroundColor:'#e94560',border:'none',padding:'6px 12px',borderRadius:'5px',color:'white',cursor:'pointer',fontSize:'13px'}}>
          Odhlásit
        </button>
        <span style={{margin:'0 auto',color: online ? '#4ade80' : '#ef4444',fontSize:'24px',fontWeight:'bold'}}>
          {online ? '● ONLINE' : `⚠️ SPOJENÍ ZTRACENO ${odpocet}`}
        </span>
      </div>

      <Menu aktivni={aktivni} setAktivni={setAktivni} role={uzivatel?.role} />

      <div style={{padding:'30px'}}>
        {aktivni === 'Přehled' && (
          <div>
            <div style={{display:'flex',gap:'100px',alignItems:'flex-end',backgroundColor:'#16213e',padding:'30px',borderRadius:'10px',marginBottom:'20px'}}>
              {pocetFazi >= 1 && <FazeSloupec nazev="L1" hodnota={d.L1_inverter_output_power||0} max={4000} />}
              {pocetFazi >= 2 && <FazeSloupec nazev="L2" hodnota={d.L2_inverter_output_power||0} max={4000} />}
              {pocetFazi >= 3 && <FazeSloupec nazev="L3" hodnota={d.L3_inverter_output_power||0} max={4000} />}
              <div style={{marginLeft:'550px'}}><BaterieSloupec hodnota={bmsAverageSoc !== null ? bmsAverageSoc : (d.battery_soc||0)}/></div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'20px',marginBottom:'20px'}}>
              <Karta nazev="Proud baterie" hodnota={d.battery_output_current||0} jednotka="A" barva="#4cc9f0" ikona="🔋" />
              <Karta nazev="PV1 Výkon" hodnota={d.PV1_input_power||0} jednotka="W" barva="#f4a261" ikona="☀️" />
              <Karta nazev="PV výroba dnes" hodnota={d.day_pv_power_wh||0} jednotka="kWh" barva="#4ade80" ikona="📊" />
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'20px'}}>
              <Karta nazev="Celkový výkon" hodnota={d.total_inverter_output_power||0} jednotka="W" barva="#e94560" ikona="⚡" />
              <Karta nazev="Napětí baterie" hodnota={d.battery_voltage||0} jednotka="V" barva="#a78bfa" ikona="🔌" />
              <Karta nazev="Spotřeba dnes" hodnota={d.day_load_power_wh||0} jednotka="kWh" barva="#fb923c" ikona="🏠" />
            </div>

            <div style={{backgroundColor:'#16213e',padding:'20px',borderRadius:'10px',marginTop:'20px'}}>
              <h3 style={{color:'#f59e0b',marginBottom:'15px'}}>⚡ Studer — Spotřeba AC-OUT</h3>
              {(() => {
                const l1 = ['01','02','03'].reduce((s,i) => s + (d[`studer${i}_ac_vystup_vykon`]||0), 0);
                const l2 = ['04','05','06'].reduce((s,i) => s + (d[`studer${i}_ac_vystup_vykon`]||0), 0);
                const l3 = ['07','08','09'].reduce((s,i) => s + (d[`studer${i}_ac_vystup_vykon`]||0), 0);
                const celkem = l1 + l2 + l3;
                const gen_status = d['studer01_rele_stav'];
                const maxKw = 12;
                return (
                  <div>
                    <div style={{display:"flex",gap:"40px",alignItems:"flex-end",marginBottom:"20px"}}>
                      <StuderSloupec nazev="L1" hodnota={l1} max={maxKw} />
                      <StuderSloupec nazev="L2" hodnota={l2} max={maxKw} />
                      <StuderSloupec nazev="L3" hodnota={l3} max={maxKw} />
                      <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"10px",marginLeft:"40px"}}>
                        <div style={{color:"#aaa",fontSize:"14px"}}>Celkem</div>
                        <div style={{color:"#e94560",fontSize:"32px",fontWeight:"bold"}}>{(celkem*1000).toFixed(0)} W</div>
                      </div>
                      <div style={{marginLeft:'20px',display:'flex',gap:'15px',alignItems:'flex-end'}}>
                        <BaterieSloupec hodnota={bmsAverageSoc !== null ? bmsAverageSoc : (d.battery_soc||0)} />
                        <div style={{display:'flex',flexDirection:'column',gap:'10px',paddingBottom:'20px'}}>
                          <div style={{backgroundColor:'#0f3460',borderRadius:'8px',padding:'10px',minWidth:'120px',textAlign:'center'}}>
                            <div style={{color:'#aaa',fontSize:'11px'}}>Napětí</div>
                            <div style={{color:'#22c55e',fontSize:'18px',fontWeight:'bold'}}>{(() => { const h=[]; for(let i=0;i<16;i++){const id=String(i).padStart(2,'0');const v=d[`bms${id}_napeti`];if(v!==undefined)h.push(v);} return h.length>0?(h.reduce((a,b)=>a+b,0)/h.length).toFixed(2):'---'; })()} V</div>
                          </div>
                          <div style={{backgroundColor:'#0f3460',borderRadius:'8px',padding:'10px',textAlign:'center'}}>
                            <div style={{color:'#aaa',fontSize:'11px'}}>Proud</div>
                            <div style={{color:'#22c55e',fontSize:'18px',fontWeight:'bold'}}>{(() => { const h=[]; for(let i=0;i<16;i++){const id=String(i).padStart(2,'0');const v=d[`bms${id}_proud`];if(v!==undefined)h.push(v);} return h.length>0?h.reduce((a,b)=>a+b,0).toFixed(2):'---'; })()} A</div>
                          </div>
                          <div style={{backgroundColor:'#0f3460',borderRadius:'8px',padding:'10px',textAlign:'center'}}>
                            <div style={{color:'#aaa',fontSize:'11px'}}>Výkon</div>
                            <div style={{color:'#22c55e',fontSize:'18px',fontWeight:'bold'}}>{(() => {
                              const hn=[]; const hp=[];
                              for(let i=0;i<16;i++){const id=String(i).padStart(2,'0');const n=d[`bms${id}_napeti`];const p=d[`bms${id}_proud`];if(n!==undefined&&p!==undefined){hn.push(n);hp.push(p);}}
                              if(hn.length>0){const n=hn.reduce((a,b)=>a+b,0)/hn.length;const p=hp.reduce((a,b)=>a+b,0);return (n*p/1000).toFixed(2)+' kW';}
                              return '---';
                            })()} </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{padding:"10px",backgroundColor:"#0f3460",borderRadius:"8px",textAlign:"center"}}>
                      <span style={{color:"#aaa",fontSize:"12px",marginRight:"10px"}}>Status generátoru:</span>
                      <span style={{color: gen_status === 1.0 ? "#4ade80" : "#aaa", fontWeight:"bold"}}>{gen_status === 1.0 ? "✅ Generátor připojen" : "○ Generátor odpojen"}</span>
                    </div>
                  </div>
                );
              })()}
            </div>
            <div style={{backgroundColor:'#16213e',padding:'20px',borderRadius:'10px',marginTop:'20px'}}>
              <h3 style={{color:'#3b82f6',marginBottom:'15px'}}>🔌 Studer — Generátor AC-IN</h3>
              {(() => {
                const l1in = d['studer01_vykon_in']||0;
                const l2in = d['studer04_vykon_in']||0;
                const l3in = d['studer07_vykon_in']||0;
                const celkemin = l1in + l2in + l3in;
                const maxKwIn = 12;
                return (
                  <div>
                    <div style={{display:'flex',gap:'40px',alignItems:'flex-end',marginBottom:'20px'}}>
                      <StuderSloupec nazev="L1" hodnota={l1in} max={maxKwIn} />
                      <StuderSloupec nazev="L2" hodnota={l2in} max={maxKwIn} />
                      <StuderSloupec nazev="L3" hodnota={l3in} max={maxKwIn} />
                      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'10px',marginLeft:'40px'}}>
                        <div style={{color:'#aaa',fontSize:'14px'}}>Celkem</div>
                        <div style={{color:'#3b82f6',fontSize:'32px',fontWeight:'bold'}}>{(celkemin*1000).toFixed(0)} W</div>
                        <div style={{color:'#aaa',fontSize:'13px'}}>{celkemin.toFixed(2)} kVA</div>
                      </div>
                    </div>
                    <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'15px'}}>
                      <div style={{backgroundColor:'#0f3460',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                        <div style={{color:'#aaa',fontSize:'12px'}}>Napětí L1</div>
                        <div style={{color:'#00b4d8',fontSize:'18px',fontWeight:'bold'}}>{(d['studer01_ac_vstup_napeti']||0).toFixed(1)} V</div>
                      </div>
                      <div style={{backgroundColor:'#0f3460',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                        <div style={{color:'#aaa',fontSize:'12px'}}>Napětí L2</div>
                        <div style={{color:'#00b4d8',fontSize:'18px',fontWeight:'bold'}}>{(d['studer04_ac_vstup_napeti']||0).toFixed(1)} V</div>
                      </div>
                      <div style={{backgroundColor:'#0f3460',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                        <div style={{color:'#aaa',fontSize:'12px'}}>Napětí L3</div>
                        <div style={{color:'#00b4d8',fontSize:'18px',fontWeight:'bold'}}>{(d['studer07_ac_vstup_napeti']||0).toFixed(1)} V</div>
                      </div>
                    <div style={{display:'grid',gridTemplateColumns:'repeat(2,1fr)',gap:'15px',marginTop:'15px'}}>
                      <div style={{backgroundColor:'#0f3460',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                        <div style={{color:'#aaa',fontSize:'12px'}}>Frekvence IN</div>
                        <div style={{color:'#00b4d8',fontSize:'18px',fontWeight:'bold'}}>{d['studer01_ac_vstup_frekvence'] ? d['studer01_ac_vstup_frekvence'].toFixed(1) + ' Hz' : '---'}</div>
                      </div>
                      <div style={{backgroundColor:'#0f3460',borderRadius:'8px',padding:'12px',textAlign:'center'}}>
                        <div style={{color:'#aaa',fontSize:'12px'}}>Status generátoru</div>
                        <div style={{color: d['studer01_rele_stav'] === 1.0 ? '#4ade80' : '#aaa',fontSize:'16px',fontWeight:'bold'}}>
                          {d['studer01_rele_stav'] === 1.0 ? '✅ Připojen' : '○ Odpojen'}
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                );
              })()}
            </div>
            <hr style={{borderColor:'#0f3460',margin:'30px 0'}} />
            <h2 style={{color:'#e94560',marginBottom:'20px'}}>🔋 Data BMS</h2>
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:'15px'}}>
            {Array.from({length:16}, (_,i) => {
              const id = String(i).padStart(2,'0');
              const napeti = d[`bms${id}_napeti`];
              const lu = d[`bms${id}_last_update`];
              const offline = lu && (Date.now() - new Date(lu).getTime()) / 1000 > 60;
              if (napeti === undefined || offline) return null;
              return (
                <div key={id} style={{backgroundColor:'#16213e',borderRadius:'8px',padding:'15px',marginBottom:'10px',borderLeft:'3px solid #22c55e'}}>
                  <div style={{color:'#22c55e',fontWeight:'bold',marginBottom:'10px',fontSize:'14px'}}>BMS {i+1}</div>
                  <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(120px,1fr))',gap:'10px'}}>
                    <div>
                      <div style={{color:'#aaa',fontSize:'11px'}}>Napětí</div>
                      <div style={{color:'#00b4d8',fontWeight:'bold'}}>{napeti?.toFixed(3)} V</div>
                    </div>
                    <div>
                      <div style={{color:'#aaa',fontSize:'11px'}}>Proud</div>
                      <div style={{color:'#00b4d8',fontWeight:'bold'}}>{d[`bms${id}_proud`]?.toFixed(2)} A</div>
                    </div>
                    <div>
                      <div style={{color:'#aaa',fontSize:'11px'}}>SOC</div>
                      <div style={{color:'#00b4d8',fontWeight:'bold'}}>{d[`bms${id}_soc`]?.toFixed(0)} %</div>
                    </div>
                    <div>
                      <div style={{color:'#aaa',fontSize:'11px'}}>Delta</div>
                      <div style={{color: d[`bms${id}_delta_mv`] > 50 ? '#ef4444' : '#00b4d8',fontWeight:'bold'}}>{d[`bms${id}_delta_mv`]?.toFixed(1)} mV</div>
                    </div>
                    <div>
                      <div style={{color:'#aaa',fontSize:'11px'}}>Teplota MOS</div>
                      <div style={{color:'#00b4d8',fontWeight:'bold'}}>{d[`bms${id}_temp_mos`]?.toFixed(1)} °C</div>
                    </div>
                    <div>
                      <div style={{color:'#aaa',fontSize:'11px'}}>Temp bat1</div>
                      <div style={{color:'#00b4d8',fontWeight:'bold'}}>{d[`bms${id}_temp_bat1`]?.toFixed(1)} °C</div>
                    </div>
                    <div>
                      <div style={{color:'#aaa',fontSize:'11px'}}>Cykly</div>
                      <div style={{color:'#00b4d8',fontWeight:'bold'}}>{d[`bms${id}_cykly`]?.toFixed(0)}</div>
                    </div>
                  </div>
                </div>
              );
            })}
            </div>

            <hr style={{borderColor:'#0f3460',margin:'30px 0'}} />
            <h2 style={{color:'#e94560',marginBottom:'20px'}}>⚡ Data Studer</h2>
            {(() => {
              const STUDER_FIELDS = {
                'napeti_baterie':    {nazev: 'Napětí baterie',    jednotka: 'V',   reg: 3000},
                'proud_baterie':     {nazev: 'Proud baterie',     jednotka: 'A',   reg: 3005},
                'ac_vstup_napeti':   {nazev: 'AC vstup napětí',   jednotka: 'V',   reg: 3011},
                'ac_vstup_proud':    {nazev: 'AC vstup proud',    jednotka: 'A',   reg: 3012},
                'ac_vstup_vykon':    {nazev: 'AC vstup výkon',    jednotka: 'kVA', reg: 3013},
                'ac_vystup_napeti':  {nazev: 'AC výstup napětí',  jednotka: 'V',   reg: 3021},
                'ac_vystup_proud':   {nazev: 'AC výstup proud',   jednotka: 'A',   reg: 3022},
                'ac_vystup_vykon':   {nazev: 'AC výstup výkon',   jednotka: 'kVA', reg: 3023},
                'faze_nabijeni':     {nazev: 'Fáze nabíjení',     jednotka: '',    reg: 3010},
                'provozni_stav':     {nazev: 'Provozní stav',     jednotka: '',    reg: 3028},
                'rele_stav':         {nazev: 'Stav relé',         jednotka: '',    reg: 3020},
                'vykon_out':         {nazev: 'Výkon out',         jednotka: 'kVA', reg: 3139},
              };
              const studery = [];
              for (let i = 1; i <= 9; i++) {
                const id = String(i).padStart(2, '0');
                if (d[`studer${id}_napeti_baterie`] !== undefined) studery.push(id);
              }
              if (studery.length === 0) return <div style={{color:'#aaa'}}>Studer není připojen</div>;
              return <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:'15px'}}>{studery.map(id => (
                <div key={id} style={{backgroundColor:'#16213e',borderRadius:'8px',padding:'15px',marginBottom:'10px',borderLeft:'3px solid #f59e0b'}}>
                  <div style={{color:'#f59e0b',fontWeight:'bold',marginBottom:'10px',fontSize:'14px'}}>Studer {parseInt(id)}</div>
                  <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(120px,1fr))',gap:'10px'}}>
                    {Object.entries(STUDER_FIELDS).map(([klic, info]) => {
                      const val = d[`studer${id}_${klic}`];
                      if (val === undefined) return null;
                      return (
                        <div key={klic}>
                          <div style={{color:'#aaa',fontSize:'11px'}}>{info.nazev}</div>
                          <div style={{color:'#f59e0b',fontWeight:'bold'}}>{Number(val).toFixed(2)} {info.jednotka}</div>
                          <div style={{color:'#ffffff',fontSize:'10px'}}>reg {info.reg}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}</div>
            })()}

          </div>
        )}

        {aktivni === 'Grafy' && <h2 style={{color:'#aaa'}}>Grafy – připravujeme...</h2>}

        {aktivni === 'Nastavení' && ['super_admin','servisni_technik','technicky_dispecer','analytik','vyvojar_sw','vyvojovy_technik','obchodnik'].includes(uzivatel?.role) && (

          <div>
            <div style={{display:'flex',gap:'10px',marginBottom:'20px'}}>
              {['DEYE','Studer'].map(tab => (
                <button key={tab} onClick={() => setNastaveniTab(tab)}
                  style={{backgroundColor:nastaveniTab===tab?'#e94560':'#16213e',color:'white',border:'none',padding:'8px 20px',borderRadius:'5px',cursor:'pointer'}}>
                  {tab}
                </button>
              ))}
            </div>
            <div style={{display:'flex',gap:'20px',alignItems:'flex-start'}}>
              <div style={{flex:1}}>
                {nastaveniTab === 'DEYE' && <NastaveniForm fveId={aktivniElektrarna} token={localStorage.getItem('token')} data={dataNastaveni} key="nastaveni" onStav={setZapisStav} hasPerm={hasPerm} />}
                {nastaveniTab === 'Studer' && <StuderNastaveniForm fveId={aktivniElektrarna} token={localStorage.getItem('token')} />}
                {zapisStav && (
                  <div style={{padding:'12px',borderRadius:'8px',marginTop:'15px',
                    backgroundColor: zapisStav.typ === 'ok' ? '#14532d' : '#7f1d1d',
                    color: zapisStav.typ === 'ok' ? '#4ade80' : '#ef4444'}}>
                    {zapisStav.zprava}
                  </div>
                )}
              </div>
              <DiagnostikaPanel fveId={aktivniElektrarna} token={localStorage.getItem('token')} />
            </div>
          </div>
        )}

        {aktivni === 'Historie' && (
          <HistoriePanel fveId={aktivniElektrarna} token={localStorage.getItem('token')} />
        )}

        {aktivni === 'Elektrárny' && (
          <ElektrarnyPanel elektrarny={elektrarny} aktivniElektrarna={aktivniElektrarna} onVybrat={(fveId) => { nastavAktivni(fveId); setAktivni('Přehled'); }} />
        )}

        {aktivni === 'Správa uživatelů' && (
          <SpravaPanel token={localStorage.getItem('token')} role={uzivatel?.role} />
        )}
      </div>
    </div>
  );
}

const SpravaPanel = ({ token, role }) => {
  const [podzalozka, setPodzalozka] = React.useState('zadosti');
  const [zadosti, setZadosti] = React.useState([]);
  const [uzivatele, setUzivatele] = React.useState([]);
  const [vsechnyPermissions, setVsechnyPermissions] = React.useState([]);
  const [vybranyUzivatel, setVybranyUzivatel] = React.useState(null);
  const [editMode, setEditMode] = React.useState(false);
  const [editData, setEditData] = React.useState({});
  const [uzivatelElektrarny, setUzivatelElektrarny] = React.useState([]);
  const [novaElektrarna, setNovaElektrarna] = React.useState('');
  const [uzivatelPermissions, setUzivatelPermissions] = React.useState(null);
  const [nacitani, setNacitani] = React.useState(true);
  const [razeniUz, setRazeniUz] = React.useState('prijmeni');
  const [smerUz, setSmerUz] = React.useState('asc');
  const [hledani, setHledani] = React.useState('');
  const [vybranaRole, setVybranaRole] = React.useState(null);
  const [rolePermissions, setRolePermissions] = React.useState([]);
  const VSECHNY_ROLE = ['super_admin','servisni_technik','technicky_dispecer','analytik','vyvojar_sw','vyvojovy_technik','obchodnik','investor','zakaznik','partner_instalacni_firma'];

  const nactiZadosti = () => {
    fetch('/api/zadosti', { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json()).then(data => { setZadosti(data); setNacitani(false); }).catch(() => setNacitani(false));
  };

  const nactiUzivatele = () => {
    fetch('/api/uzivatele', { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) setUzivatele(data.map(u => ({...u, pocet_elektrarny: 0})));
      }).catch(() => {});
    fetch('/api/permissions', { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setVsechnyPermissions(data); }).catch(() => {});
  };

  const vyridit = async (id, akce) => {
    await fetch(`/api/zadost_schvalit/${id}`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ akce })
    });
    nactiZadosti();
  };

  const nactiRolePermissions = (role) => {
    setVybranaRole(role);
    fetch(`/api/role_permissions/${role}`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setRolePermissions(data); }).catch(() => {});
  };

  const toggleRolePermission = async (role, permissionId, aktualne) => {
    const method = aktualne ? 'DELETE' : 'POST';
    await fetch(`/api/role_permissions/${role}/${permissionId}`, {
      method, headers: { 'Authorization': `Bearer ${token}` }
    });
    nactiRolePermissions(role);
  };

  const nactiUzivatelPermissions = (uzivatel) => {
    setVybranyUzivatel(uzivatel);
    setEditMode(false);
    fetch(`/api/uzivatel/${uzivatel.id}/permissions`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json()).then(data => setUzivatelPermissions(data)).catch(() => {});
    fetch(`/api/uzivatel/${uzivatel.id}/elektrarny`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setUzivatelElektrarny(data); }).catch(() => {});
  };

  const setPermissionOverride = async (userId, permissionId, povoleno, expiruje) => {
    await fetch(`/api/uzivatel/${userId}/permission_override`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ permission_id: permissionId, povoleno, expiruje_at: expiruje })
    });
    nactiUzivatelPermissions(vybranyUzivatel);
  };

  const resetPermission = async (userId, permissionId) => {
    await fetch(`/api/uzivatel/${userId}/permission_override/${permissionId}`, {
      method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` }
    });
    nactiUzivatelPermissions(vybranyUzivatel);
  };

  const zmenRoli = async (userId, novaRole) => {
    await fetch(`/api/uzivatel/${userId}/role`, {
      method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ role: novaRole })
    });
    nactiUzivatele();
    if (vybranyUzivatel && vybranyUzivatel.id === userId) {
      nactiUzivatelPermissions({...vybranyUzivatel, role: novaRole});
    }
  };

  const expiraceZa2h = () => {
    const d = new Date();
    d.setHours(d.getHours() + 2);
    return d.toISOString();
  };

  React.useEffect(() => { nactiZadosti(); nactiUzivatele(); }, []);
  const btnStyle = (aktivni) => ({
    backgroundColor: aktivni ? '#e94560' : '#0f3460',
    color: 'white', border: 'none', padding: '8px 16px',
    borderRadius: '5px', cursor: 'pointer', fontSize: '13px', marginRight: '8px'
  });

  return (
    <div>
      <h2 style={{color:'#e94560',marginBottom:'20px'}}>🔧 Správa uživatelů</h2>
      <div style={{marginBottom:'20px'}}>
        <button style={btnStyle(podzalozka==='zadosti')} onClick={() => setPodzalozka('zadosti')}>📋 Žádosti o přístup</button>
        <button style={btnStyle(podzalozka==='uzivatele')} onClick={() => setPodzalozka('uzivatele')}>👥 Seznam uživatelů</button>
        <button style={btnStyle(podzalozka==='role')} onClick={() => setPodzalozka('role')}>🛡 Správa rolí</button>
      </div>

      {podzalozka === 'zadosti' && (
        <div>
          <h3 style={{color:'#aaa',marginBottom:'15px'}}>Čekající žádosti</h3>
          {nacitani ? <div style={{color:'#aaa'}}>Načítám...</div> :
            zadosti.filter(z => z.stav === 'ceka').length === 0
              ? <div style={{color:'#aaa',marginBottom:'20px'}}>Žádné čekající žádosti</div>
              : zadosti.filter(z => z.stav === 'ceka').map(z => (
                <div key={z.id} style={{backgroundColor:'#16213e',borderRadius:'8px',padding:'15px',marginBottom:'10px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div>
                    <div style={{color:'white',fontWeight:'bold'}}>{z.email}</div>
                    <div style={{color:'#aaa',fontSize:'13px'}}>Žádá o přístup k: <span style={{color:'#00b4d8'}}>{z.fve_id}</span></div>
                    <div style={{color:'#aaa',fontSize:'12px'}}>{z.vytvoreno}</div>
                  </div>
                  <div style={{display:'flex',gap:'10px'}}>
                    <button onClick={() => vyridit(z.id, 'schvalit')} style={{backgroundColor:'#4ade80',border:'none',padding:'8px 16px',borderRadius:'5px',color:'#000',cursor:'pointer',fontWeight:'bold'}}>✓ Schválit</button>
                    <button onClick={() => vyridit(z.id, 'zamitnout')} style={{backgroundColor:'#ef4444',border:'none',padding:'8px 16px',borderRadius:'5px',color:'white',cursor:'pointer',fontWeight:'bold'}}>✗ Zamítnout</button>
                  </div>
                </div>
              ))
          }
          {role === 'super_admin' && (
            <div>
              <h3 style={{color:'#aaa',marginBottom:'15px',marginTop:'20px'}}>Historie žádostí</h3>
              {zadosti.filter(z => z.stav !== 'ceka').length === 0
                ? <div style={{color:'#aaa'}}>Žádná historie</div>
                : zadosti.filter(z => z.stav !== 'ceka').map(z => (
                  <div key={z.id} style={{backgroundColor:'#16213e',borderRadius:'8px',padding:'12px',marginBottom:'8px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <div>
                      <div style={{color:'#ccc',fontSize:'14px'}}>{z.email} → <span style={{color:'#00b4d8'}}>{z.fve_id}</span></div>
                      <div style={{color: z.stav==='schvaleno' ? '#4ade80' : '#ef4444', fontSize:'12px'}}>{z.stav} · {z.vytvoreno}</div>
                    </div>
                    <button onClick={async () => {
                      await fetch(`/api/zadost_pristup/${z.id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
                      nactiZadosti();
                    }} style={{backgroundColor:'#3a1a1a',border:'none',padding:'6px 12px',borderRadius:'5px',color:'#ef4444',cursor:'pointer',fontSize:'12px'}}>
                      🗑 Smazat
                    </button>
                  </div>
                ))
              }
            </div>
          )}
        </div>
      )}

      {podzalozka === 'uzivatele' && (
        <div style={{display:'flex',gap:'20px'}}>
          <div style={{flex:1}}>
            <h3 style={{color:'#aaa',marginBottom:'10px'}}>Uživatelé</h3>
            <input value={hledani} onChange={e => setHledani(e.target.value)} placeholder="🔍 Hledat..."
              style={{width:'100%',padding:'8px',marginBottom:'10px',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'5px',color:'white',fontSize:'13px',boxSizing:'border-box'}} />
            <div style={{display:'flex',gap:'6px',marginBottom:'12px'}}>
              {[['prijmeni','Příjmení'],['email','Email'],['vytvoreno','Datum']].map(([k,l]) => (
                <button key={k} onClick={() => { if(razeniUz===k) setSmerUz(s=>s==='asc'?'desc':'asc'); else {setRazeniUz(k);setSmerUz('asc');} }}
                  style={{backgroundColor: razeniUz===k ? '#e94560' : '#0f3460',color:'white',border:'none',padding:'4px 10px',borderRadius:'4px',cursor:'pointer',fontSize:'12px'}}>
                  {l} {razeniUz===k ? (smerUz==='asc'?'▲':'▼') : ''}
                </button>
              ))}
            </div>


            {[...uzivatele].filter(u => !hledani || `${u.jmeno} ${u.prijmeni} ${u.email} ${u.role}`.toLowerCase().includes(hledani.toLowerCase())).sort((a,b) => { const av=a[razeniUz]||'',bv=b[razeniUz]||''; return smerUz==='asc'?av.localeCompare(bv):bv.localeCompare(av); }).map(u => (
              <div key={u.id} onClick={() => nactiUzivatelPermissions(u)}
                style={{backgroundColor: vybranyUzivatel?.id===u.id ? '#1a3a5c' : '#16213e',borderRadius:'8px',padding:'12px',marginBottom:'8px',cursor:'pointer',borderLeft:`3px solid ${vybranyUzivatel?.id===u.id ? '#e94560' : '#0f3460'}`}}>
                <div style={{color:'white',fontSize:'14px'}}>{u.jmeno} {u.prijmeni}</div>
                <div style={{color:'#aaa',fontSize:'12px'}}>{u.email}</div>
                <div style={{color:'#00b4d8',fontSize:'12px'}}>{u.role}</div>
              </div>
            ))}
          </div>
          {vybranyUzivatel && uzivatelPermissions && (
            <div style={{flex:2}}>
              <h3 style={{color:'#aaa',marginBottom:'10px'}}>
                {vybranyUzivatel.jmeno} {vybranyUzivatel.prijmeni}
                <span style={{color:'#00b4d8',fontSize:'13px',marginLeft:'10px'}}>{uzivatelPermissions.role}</span>
              </h3>
              <div style={{marginBottom:'15px'}}>
                <label style={{color:'#aaa',fontSize:'12px',marginRight:'8px'}}>Změnit roli:</label>
                <select value={uzivatelPermissions.role} onChange={e => zmenRoli(vybranyUzivatel.id, e.target.value)}
                  style={{backgroundColor:'#0f3460',color:'white',border:'1px solid #333',borderRadius:'5px',padding:'4px 8px',fontSize:'13px'}}>
                  {VSECHNY_ROLE.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </div>
              <button onClick={async () => {
                if (!window.confirm(`Opravdu chcete smazat účet ${vybranyUzivatel.email}?`)) return;
                if (!window.confirm('Tato akce je nevratná. Potvrďte smazání.')) return;
                await fetch(`/api/uzivatel/${vybranyUzivatel.id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
                setVybranyUzivatel(null);
                setUzivatelPermissions(null);
                nactiUzivatele();
              }} style={{backgroundColor:'#7f1d1d',border:'none',padding:'6px 14px',borderRadius:'5px',color:'#ef4444',cursor:'pointer',fontSize:'13px',marginTop:'10px'}}>
                🗑 Smazat účet
              </button>
              <div style={{marginTop:'15px',marginBottom:'15px',padding:'12px',backgroundColor:'#0f3460',borderRadius:'8px'}}>
                {!editMode ? (
                  <button onClick={() => { setEditMode(true); setEditData({jmeno: vybranyUzivatel.jmeno, prijmeni: vybranyUzivatel.prijmeni, email: vybranyUzivatel.email}); }}
                    style={{backgroundColor:'#1e40af',border:'none',padding:'6px 14px',borderRadius:'5px',color:'white',cursor:'pointer',fontSize:'13px'}}>
                    ✏️ Upravit údaje
                  </button>
                ) : (
                  <div>
                    <div style={{display:'flex',gap:'10px',marginBottom:'8px'}}>
                      <input value={editData.jmeno||''} onChange={e => setEditData({...editData, jmeno: e.target.value})} placeholder="Jméno"
                        style={{flex:1,padding:'6px',backgroundColor:'#16213e',border:'1px solid #333',borderRadius:'5px',color:'white',fontSize:'13px'}} />
                      <input value={editData.prijmeni||''} onChange={e => setEditData({...editData, prijmeni: e.target.value})} placeholder="Příjmení"
                        style={{flex:1,padding:'6px',backgroundColor:'#16213e',border:'1px solid #333',borderRadius:'5px',color:'white',fontSize:'13px'}} />
                    </div>
                    <input value={editData.email||''} onChange={e => setEditData({...editData, email: e.target.value})} placeholder="Email"
                      style={{width:'100%',padding:'6px',backgroundColor:'#16213e',border:'1px solid #333',borderRadius:'5px',color:'white',fontSize:'13px',boxSizing:'border-box',marginBottom:'8px'}} />
                    <div style={{display:'flex',gap:'8px'}}>
                      <button onClick={async () => {
                        await fetch(`/api/uzivatel/${vybranyUzivatel.id}`, {
                          method: 'PATCH', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                          body: JSON.stringify(editData)
                        });
                        setEditMode(false);
                        nactiUzivatele();
                        nactiUzivatelPermissions({...vybranyUzivatel, ...editData});
                      }} style={{backgroundColor:'#14532d',border:'none',padding:'6px 14px',borderRadius:'5px',color:'#4ade80',cursor:'pointer',fontSize:'13px'}}>
                        ✓ Uložit
                      </button>
                      <button onClick={() => setEditMode(false)}
                        style={{backgroundColor:'#3a1a1a',border:'none',padding:'6px 14px',borderRadius:'5px',color:'#ef4444',cursor:'pointer',fontSize:'13px'}}>
                        ✗ Zrušit
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div style={{marginBottom:'15px'}}>
                <h4 style={{color:'#aaa',fontSize:'13px',marginBottom:'8px'}}>⚡ Elektrárny</h4>
                {uzivatelElektrarny.map(e => (
                  <div key={e.id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',backgroundColor:'#16213e',borderRadius:'5px',padding:'6px 10px',marginBottom:'4px'}}>
                    <span style={{color:'#00b4d8',fontSize:'13px'}}>{e.fve_id} — {e.nazev || '—'}</span>
                    <button onClick={async () => {
                      await fetch(`/api/uzivatel/${vybranyUzivatel.id}/elektrarny/${e.id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
                      nactiUzivatelPermissions(vybranyUzivatel);
                    }} style={{backgroundColor:'#3a1a1a',border:'none',padding:'3px 8px',borderRadius:'4px',color:'#ef4444',cursor:'pointer',fontSize:'11px'}}>
                      ✗ Odebrat
                    </button>
                  </div>
                ))}
                <div style={{display:'flex',gap:'6px',marginTop:'6px'}}>
                  <input value={novaElektrarna} onChange={e => setNovaElektrarna(e.target.value)} placeholder="FVE ID (např. FVE001)"
                    style={{flex:1,padding:'5px',backgroundColor:'#0f3460',border:'1px solid #333',borderRadius:'4px',color:'white',fontSize:'12px'}} />
                  <button onClick={async () => {
                    if (!novaElektrarna) return;
                    await fetch(`/api/uzivatel/${vybranyUzivatel.id}/elektrarny`, {
                      method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                      body: JSON.stringify({ fve_id: novaElektrarna })
                    });
                    setNovaElektrarna('');
                    nactiUzivatelPermissions(vybranyUzivatel);
                  }} style={{backgroundColor:'#1e40af',border:'none',padding:'5px 10px',borderRadius:'4px',color:'white',cursor:'pointer',fontSize:'12px'}}>
                    + Přidat
                  </button>
                </div>
              </div>
              <h4 style={{color:'#aaa',fontSize:'13px',marginBottom:'10px'}}>Oprávnění:</h4>
              {vsechnyPermissions.map(p => {
                const uzivPerm = uzivatelPermissions.permissions.find(up => up.id === p.id);
                const maPermZRole = uzivPerm?.z_role && uzivPerm?.povoleno !== false;
                const maOverride = uzivPerm?.override !== undefined && uzivPerm?.override !== null;
                const aktualne = maOverride ? uzivPerm.override : maPermZRole;
                return (
                  <div key={p.id} style={{backgroundColor:'#16213e',borderRadius:'6px',padding:'10px',marginBottom:'6px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <div>
                      <div style={{color: aktualne ? 'white' : '#555',fontSize:'13px'}}>{p.popis}</div>
                      <div style={{fontSize:'11px',color: maOverride ? '#f59e0b' : '#444'}}>
                        {maOverride ? `⚡ Override${uzivPerm.expiruje_at ? ` (vyprší: ${new Date(uzivPerm.expiruje_at).toLocaleString('cs')})` : ''}` : (maPermZRole ? '● z role' : '○ není v roli')}
                      </div>
                    </div>
                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                      {maOverride && (
                        <button onClick={() => resetPermission(vybranyUzivatel.id, p.id)}
                          style={{backgroundColor:'#3a1a1a',border:'none',padding:'4px 8px',borderRadius:'4px',color:'#f59e0b',cursor:'pointer',fontSize:'11px'}}>
                          Reset
                        </button>
                      )}
                      <button onClick={() => setPermissionOverride(vybranyUzivatel.id, p.id, !aktualne, expiraceZa2h())}
                        style={{backgroundColor: aktualne ? '#14532d' : '#3a1a1a',border:'none',padding:'4px 10px',borderRadius:'4px',color: aktualne ? '#4ade80' : '#ef4444',cursor:'pointer',fontSize:'12px'}}>
                        {aktualne ? '✓ Povoleno' : '✗ Zakázáno'}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
      {podzalozka === 'role' && (
        <div style={{display:'flex',gap:'20px'}}>
          <div style={{flex:'0 0 200px'}}>
            <h3 style={{color:'#aaa',marginBottom:'15px'}}>Role</h3>
            {VSECHNY_ROLE.map(r => (
              <div key={r} onClick={() => nactiRolePermissions(r)}
                style={{backgroundColor: vybranaRole===r ? '#1a3a5c' : '#16213e',borderRadius:'8px',padding:'10px 14px',marginBottom:'6px',cursor:'pointer',borderLeft:`3px solid ${vybranaRole===r ? '#e94560' : '#0f3460'}`,color: vybranaRole===r ? 'white' : '#ccc',fontSize:'13px'}}>
                {r}
              </div>
            ))}
          </div>
          {vybranaRole && (
            <div style={{flex:1}}>
              <h3 style={{color:'#aaa',marginBottom:'15px'}}>Oprávnění role: <span style={{color:'#e94560'}}>{vybranaRole}</span></h3>
              {rolePermissions.map(p => (
                <div key={p.id} style={{backgroundColor:'#16213e',borderRadius:'6px',padding:'10px',marginBottom:'6px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div>
                    <div style={{color: p.povoleno ? 'white' : '#555',fontSize:'13px'}}>{p.popis}</div>
                    <div style={{color:'#444',fontSize:'11px'}}>{p.nazev}</div>
                  </div>
                  <button onClick={() => toggleRolePermission(vybranaRole, p.id, p.povoleno)}
                    style={{backgroundColor: p.povoleno ? '#14532d' : '#3a1a1a',border:'none',padding:'4px 10px',borderRadius:'4px',color: p.povoleno ? '#4ade80' : '#ef4444',cursor:'pointer',fontSize:'12px'}}>
                    {p.povoleno ? '✓ Povoleno' : '✗ Zakázáno'}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const DiagnostikaPanel = ({ fveId, token }) => {
  const [stav, setStav] = React.useState(null);
  const [nacitani, setNacitani] = React.useState(true);

  React.useEffect(() => {
    const nacti = () => {
      fetch(`/api/diagnostika/${fveId}`, {headers: {'Authorization': `Bearer ${token}`}})
        .then(r => r.json())
        .then(data => { setStav(data); setNacitani(false); })
        .catch(() => setNacitani(false));
    };
    nacti();
    const interval = setInterval(nacti, 10000);
    return () => clearInterval(interval);
  }, [fveId, token]);

  const radek = (nazev, hodnota) => {
    const ok = hodnota === 'OK';
    return (
      <div style={{display:'flex',justifyContent:'space-between',padding:'6px 0',borderBottom:'1px solid #0f3460'}}>
        <span style={{color:'#aaa',fontSize:'13px'}}>{nazev}</span>
        <span style={{color: ok ? '#4ade80' : '#ef4444',fontSize:'13px',fontWeight:'bold'}}>{ok ? '✅ OK' : '❌ ' + hodnota}</span>
      </div>
    );
  };

  return (
    <div style={{backgroundColor:'#16213e',borderRadius:'8px',padding:'16px',minWidth:'220px',maxWidth:'260px'}}>
      <div style={{color:'#e94560',fontSize:'14px',fontWeight:'bold',marginBottom:'12px'}}>🔌 Diagnostika</div>
      {nacitani ? <div style={{color:'#aaa',fontSize:'13px'}}>Načítám...</div> : stav ? (
        <div>
          {radek('PC → Server', 'OK')}
          {radek('Server → MQTT', stav.mqtt)}
          {radek('Server → Raspberry', stav.vpn_raspberry)}
          {radek('Raspberry → MQTT', stav.raspberry_mqtt || 'NEZNÁMÝ')}
          {radek('Raspberry → RS485', stav.raspberry?.rs485 || 'NEZNÁMÝ')}
          {radek('RS485 → DEYE', stav.raspberry?.deye_main || 'NEZNÁMÝ')}
          {radek('DEYE → Data', stav.raspberry?.deye_data || 'NEZNÁMÝ')}
          {radek('RS485 → BMS', stav.raspberry?.seplos_main || 'NEZNÁMÝ')}
        </div>
      ) : <div style={{color:'#ef4444',fontSize:'13px'}}>Chyba načítání</div>}
    </div>
  );
};

const HistoriePanel = ({ fveId, token }) => {
  const [obsah, setObsah] = React.useState('');
  const [nacitani, setNacitani] = React.useState(false);

  React.useEffect(() => {
    setNacitani(true);
    fetch(`/api/historie/${fveId}`, {headers: {'Authorization': `Bearer ${token}`}})
      .then(r => r.json())
      .then(data => { setObsah(data.obsah || 'Žádná historie'); setNacitani(false); })
      .catch(() => { setObsah('Chyba načítání'); setNacitani(false); });
  }, [fveId]);

  return (
    <div>
      <h2 style={{color:'#e94560',marginBottom:'20px'}}>📋 Historie změn</h2>
      {nacitani ? <p style={{color:'#aaa'}}>Načítám...</p> :
        <pre style={{color:'#ccc',fontSize:'13px',whiteSpace:'pre-wrap',backgroundColor:'#1a1a2e',padding:'20px',borderRadius:'8px'}}>{obsah}</pre>}
    </div>
  );
};

export default App;

